<template>
  <el-dialog title="部门信息"
             :visible.sync="dialogFormVisible"
             custom-class="medium-dialog"
             center
             :close-on-click-modal="false"
             :modal="true">
    <el-form :model="form" ref="form1" :rules="rules">
      <el-row :class="{Hid:AddTopDept}" v-if="!form.independent=='1'">
        <el-col :span="24">
          <el-form-item label="上级部门" :label-width="formLabelWidth" prop="parentdName">
            <el-input v-model="form.parentdName" auto-complete="off" :required="true" v-if="false"></el-input>
            <CommonTree
              ref="treeDserialTop"
              :needTopNode="false"
              :isShowCheckBox="false"
              :treeHeight="200"
              :onlyShowGroupType="true"
              :topNodeText="'顶级部门'"
              :searchText="form.parentdName"
              @check="checktree2"
              @afterBindTree="afterBindTree">
            </CommonTree>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row hidden="hidden">
        <el-col :span="16">
          <el-form-item label="上级部门编码" :label-width="formLabelWidth" prop="parentdserial">
            <el-input v-model="form.parentdserial" auto-complete="off" :required="true" readonly></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item :label="form.independent=='1'?'门店名称':'部门名称'" :label-width="formLabelWidth" prop="dname">
          <el-input v-model="form.dname" auto-complete="off" :required="true" ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :class="{Hid:AddTopDept}" v-show="false">
        <el-col :span="24">
          <el-form-item label="分公司" :label-width="formLabelWidth" prop="independent">
            <template>
              <el-radio v-model="form.independent" label="1">是</el-radio>
              <el-radio v-model="form.independent" label="0">否</el-radio>
            </template>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="form.independent=='1'">
        <el-col :span="24">
          <el-form-item label="销货单抬头：" :label-width="formLabelWidth" prop="remark">
            <el-input v-model="form.remark"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="form.independent=='1'">
        <el-col :span="8">
          <el-form-item label="所属大区：" :label-width="formLabelWidth" prop="region">
            <el-select v-model="form.region" placeholder="请选择" clearable >
            <el-option  v-for="item in regionlist"  :key="item" :label="item" :value="item"></el-option>
          </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="性质：" :label-width="formLabelWidth" prop="nature">
            <el-select v-model="form.nature" placeholder="请选择" clearable >
              <el-option  v-for="item in naturelist"  :key="item" :label="item" :value="item"></el-option>
            </el-select>
          </el-form-item>
        </el-col>
          <el-col :span="8">
            <el-form-item label="等级：" :label-width="formLabelWidth" prop="deptlevel">
              <el-select v-model="form.deptlevel" placeholder="请选择" clearable >
                <el-option  v-for="item in levellist"  :key="item" :label="item" :value="item"></el-option>
              </el-select>
            </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="form.independent=='1'">
        <el-col :span="12">
          <el-form-item label="抖音ID：" :label-width="formLabelWidth" prop="tiktokid">
            <el-input v-model="form.tiktokid" auto-complete="off" :required="true" ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="美团ID：" :label-width="formLabelWidth" prop="meituanid">
            <el-input v-model="form.meituanid" auto-complete="off" :required="true" ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="form.independent=='1'">
        <el-col :span="24">
      <el-form-item label="地址：" :label-width="formLabelWidth" prop="province">
        <v-distpicker :province="form.province" @province="onChangeProvince" :city="form.city"
                      @city="onChangeCity" :area="form.county" @area="onChangeArea"></v-distpicker>
      </el-form-item>
        </el-col>
      </el-row>
      <el-row v-if="form.independent=='1'">
        <el-col :span="24">
      <el-form-item prop="address" :label-width="formLabelWidth">
        <el-input v-model="form.address" placeholder="详细地址"  ></el-input>
      </el-form-item>
      </el-col>
      </el-row>
      <el-row  v-if="form.independent=='1'">
        <el-col :span="8">
          <el-form-item label="定位" :label-width="formLabelWidth" >
            <el-input  v-model="form.y" size="medium" style="width: 180px">
              <template slot="prepend">经度</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-input  v-model="form.x" size="medium" style="width: 180px">
            <template slot="prepend">纬度</template>
          </el-input>
        </el-col>
        <el-col :span="7">
          <el-button size="medium" @click="getLocation">定位</el-button>
        </el-col>
      </el-row>
      <el-row v-if="form.independent=='1'">
        <el-col :span="12">
          <el-form-item label="营业时间" :label-width="formLabelWidth" prop="businesshours">
            <el-input v-model="form.businesshours" auto-complete="off" placeholder="如 10:00-22:00"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
      <el-form-item  label="电话：" :label-width="formLabelWidth">
        <el-input v-model="form.tel" maxlength="15" show-word-limit ></el-input>
      </el-form-item>
      </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item label="排序" :label-width="formLabelWidth" prop="dsortnum">
            <el-input-number v-model="form.dsortnum" auto-complete="off" :required="true" :controls="false" style="width: 100px"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="折扣显示比例" :label-width="formLabelWidth" prop="dsortnum">
            <el-input-number v-model="form.discount" auto-complete="off" :controls="false" :precision="0" style="width: 100px"></el-input-number>%
          </el-form-item>
        </el-col>
        <el-col :span="12" v-if="false&&!this.Independentserial">
          <el-form-item label="关联往来单位" :label-width="formLabelWidth" prop="customerserial">
            <el-input v-model="form.customerserial" auto-complete="off" :required="true" ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="" :label-width="formLabelWidth" >
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click="saveData" :disabled="isDisable">保 存</el-button>
      <Location ref="Location" @afterLocation="afterLocation"></Location>
    </div>
  </el-dialog>
</template>
<script>
  import {saveData, getDetail, getSerialnum} from '@/api/set/dept';
  import SelEmployee from '../../common/CommonTree'
  import Location from './Location';
  import {detailglob} from '@/api/set/parameter';

  export default {
    name: "DataContactEdit",
    data() {
      var validatorParent = (rule, value, callback) => {
        if (!this.AddTopDept && !value) {
          return callback(new Error('请选择上级部门'));
        } else {
          callback();
        }
      };

      return {
        dialogFormVisible: false,
        isDisable: false,
        Independentserial:false,
        regionlist:[],
        naturelist:[],
        levellist:[],
        tenantid:'',
        form: {  //表单数据
          serialnum: '',
          parentdserial: '',//上级部门编码
          parentdName: '',//上级部门
          dname: '',
          independent: '0',
          dsortnum: '',
          customerserial: '',
          flag: true,
          fdpath:'',
          adress: '',
          county: '',
          deptlevel:'',
          tiktokid:'',
          meituanid:'',
          city: '',
          province: '',
          remark:'',
          tel: '',
          unitguid: '',
          nature:'',
          region:'',
          y:'',
          x:'',
          businesshours:'',
          tenantid:'',
          discount:null
        },
        formLabelWidth: '120px',
        AddTopDept: false,
        focusdname:true,
        initdserial:'',
        initdname:'',
        DeptListData:[],
        rules: {////////定义正则验证字段。
          parentdName: [
            {validator: validatorParent, trigger: 'blur'},
          ],
          dname: [
            {required: true, message: '请输入名称', trigger: 'blur'},
          ],
          province: [{ required: true, message: '请选择地址', trigger: 'blur' }],
          address: [
            { required: true, message: '请填写详细地址', trigger: 'blur' },
          ],
        },
      }
    },
    methods: {
      onChangeProvince(data) {
        if (data.value == '省') data.value = '';
        this.form.province = data.value;
      },
      onChangeCity(data) {
        if (data.value == '市') data.value = '';
        this.form.city = data.value;
      },
      onChangeArea(data) {
        if (data.value == '区' || data.value == '县') data.value = '';
        this.form.county = data.value;
      },
      afterBindTree(data) {
        this.DeptListData = data;
        this.AddTopDept = data.length == 0 || this.form.fdpath.length == 4;
        if (this.form.flag) {//新增
          if (!this.AddTopDept) {
            if (this.form.parentdserial == '') {//取第一个
              this.form.parentdserial = data[0].id;
              this.form.parentdName = data[0].text;
            }
          }
        } else {//修改
          this.getDanembegin();
        }
      },
      //定位
      getLocation(){
        if(!this.form.address||!this.form.province||!this.form.city||!this.form.county){
          this.$message({
            message: '请先填写完整地址！',
            type: 'error'
          })
          return;
        }
        this.$refs.Location.show(this.form.y,this.form.x,this.form.province+this.form.city+this.form.county+this.form.address);
      },
      //定位后
      afterLocation(y,x){
        this.form.y=y;
        this.form.x=x;
      },
      getDanembegin() {
        if (this.DeptListData.length > 0 && this.form.parentdserial != '' ) {//&& !this.AddTopDept
          this.form.parentdName = this.getDName(this.form.parentdserial, this.DeptListData);
        }
      },
      getDName(dserial, arr) {
        for (var item in arr) {
          if (arr[item].id == dserial) {
            return arr[item].text;
          } else {
            if (arr[item].hasChildren) {
              var DName = this.getDName(dserial, arr[item].children);
              if (DName != '')
                return DName;
            }
          }
        }
        return "";
      },
      checktree2(guids, names, arr) {
        this.form.parentdserial = guids;
        this.form.parentdName = names;
      },
      show() {
        this.dialogFormVisible = true;
      },
      saveData() {
        this.$refs.form1.validate((valid) => {
          if (valid) {
            this.isDisable = true;
            saveData(this.form, this.form.flag).then(response => {
              if (response.data.code === 0) {
                this.$message({
                  message: '保存成功',
                  type: 'success'
                })
                if (this.form.flag) {//新增状态下 不关闭窗口
                  var pname = this.form.parentdName;
                  var pserial = this.form.parentdserial;
                  this.initForm();
                  this.form.parentdserial = pserial;
                  this.form.parentdName = pname;
                } else {
                  this.dialogFormVisible = false;
                }
                //刷新列表
                if (this.$refs.treeDserialTop)
                  this.$refs.treeDserialTop.bindData();
                this.$emit('bindGrid');
                this.$emit('refreshTree');
              } else {
                this.$message({
                  message: response.data.msg,
                  type: 'error'
                })
              }
              this.isDisable = false;
            });
          }
        })
      },
      initData(serialnum,tenantid) {
        this.initForm();
        this.form.flag = false;
        getDetail({serialnum: serialnum,tenantid:tenantid}).then(response => {
          this.form.fdpath = response.data.obj.fdpath;
          this.form = response.data.obj;
          this.AddTopDept = this.form.fdpath.length == 4;
          this.getDanembegin();
          if (this.AddTopDept)
            this.form.parentdName = '';
        });
      },
      addDialog(parentdname, parentdserial, independent) {
        this.initForm();
        this.form.flag = true;
        this.form.fdpath = '';
        this.form.parentdserial = parentdserial;
        this.form.parentdName = parentdname;
        this.form.independent = independent.toString();
        if (this.form.parentdserial == '' && this.DeptListData.length > 0) {//取第一个
          this.form.parentdserial = this.DeptListData[0].id;
          this.form.parentdName = this.DeptListData[0].text;
        }
        if (this.DeptListData.length > 0)
          this.AddTopDept = false;
        this.show();
      },
      initForm() {
        if (this.$refs.form1 !== undefined) {
          this.$refs.form1.resetFields();
          this.focusdname = true;
        }
        this.form.parentdName = '';
        this.form.adress = '';
        this.form.county = '';
        this.form.city = '';
        this.form.province = '';
        this.form.tel = '';
        this.form.x=''
        this.form.y=''
        this.form.nature=''
        this.form.region=''
        this.form.businesshours=''
        this.form.unitguid = '';
        this.form.discount=false;
      },
    },
    mounted() {
      var userInfoModel = JSON.parse(localStorage.getItem("hpapi_userInfoModel"));
      if(userInfoModel.independentserial&&userInfoModel.independentserial!='')
         this.Independentserial=true;
      detailglob({paraname:'门店所属大区'}).then(response=> {
        if (response.data.code == 0&&response.data.obj&&response.data.obj.paracontent) {
          this.regionlist=response.data.obj.paracontent.split(';');
        }
      });
      detailglob({paraname:'门店性质分类'}).then(response=> {
        if (response.data.code == 0&&response.data.obj&&response.data.obj.paracontent) {
          this.naturelist=response.data.obj.paracontent.split(';');
        }
      });
      detailglob({paraname:'门店等级'}).then(response=> {
        if (response.data.code == 0&&response.data.obj&&response.data.obj.paracontent) {
          this.levellist=response.data.obj.paracontent.split(';');
        }
      });
    },
    components: {
      SelEmployee,
      Location
    }
  }
</script>


<style scoped>
  .Hid {
    display:none;
  }
</style>





// WEBPACK FOOTER //
// src/components/set/dept/DeptEdit.vue